"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencySign = exports.CurrencyDisplay = void 0;
exports.CurrencyDisplay = {
    SYMBOL: "symbol",
    NARROW_SYMBOL: "narrowSymbol",
    CODE: "code",
    NAME: "name",
};
exports.CurrencySign = {
    ACCOUNTING: "accounting",
    STANDARD: "standard",
};
//# sourceMappingURL=Currency.types.js.map